var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading||_vm.iframeLoading),expression:"loading||iframeLoading"}],staticClass:"about-container"},[_c('iframe',{staticClass:"about-iframe",attrs:{"src":_vm.data,"frameborder":"0"},on:{"load":_vm.onload}})])
}
var staticRenderFns = []

export { render, staticRenderFns }